var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLaptopIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "111px",
    height: "64px",
    viewBox: "0 0 111 64",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_Laptop_84266"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.2455 59.0047C37.8063 59.0047 37.5415 58.7741 37.5415 58.6748C37.5415 58.2422 37.1906 57.888 36.757 57.8891L0 57.8891L0 3.60497C0 1.61655 1.61655 0 3.60386 0L85.3992 0C87.3865 0 89.0041 1.61766 89.0041 3.60497L89.0041 57.888L52.2472 57.888C51.8124 57.888 51.4615 58.2411 51.4615 58.6748C51.4615 58.7741 51.1956 59.0047 50.7586 59.0047L38.2455 59.0047ZM3.60386 2.22566C2.84359 2.22566 2.22455 2.84469 2.22455 3.60497L2.22455 56.3068L86.7785 56.3068L86.7785 3.60497C86.7785 2.84469 86.1583 2.22566 85.3981 2.22566L3.60386 2.22566Z",
    transform: "translate(10.68579 0.8507586)",
    id: "Shape",
    fill: "#FFDA1A",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.388 3.62262C107.948 3.62262 109.923 2.23448 109.923 2.23448L109.952 2.23007L109.952 0L62.7355 0C62.7355 0.612414 62.0668 1.11448 61.2469 1.11448L48.7338 1.11448C47.915 1.11448 47.2452 0.612414 47.2452 0L0.0286897 0L0.0286897 2.23007L0 2.23448C0 2.23448 1.97628 3.62262 5.536 3.62262L104.388 3.62262Z",
    transform: "translate(0.1964138 59.52662)",
    id: "Path",
    fill: "#FFDA1A",
    stroke: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptopIcon);
export default __webpack_public_path__ + "static/media/laptop-icon.3b8c75b3bb6eb328dafea4e2710c4681.svg";
export { ForwardRef as ReactComponent };